/**
 * Associated Collection Swatches - Web Components Implementation
 * 
 * This module provides web components for dynamic color swatches generated from
 * associated collections, with intelligent size availability management and
 * performance optimizations.
 */

/**
 * Utility functions
 */
function getProductHandleFromUrl(url) {
	if (!url || typeof url !== 'string') return null;
	var match = url.match(/\/products\/([^\/\?]+)/);
	return match ? match[1] : null;
}

function isValidProductData(product) {
	return product && 
		   typeof product === 'object' && 
		   Array.isArray(product.variants) && 
		   product.variants.length > 0;
}

function getProductDataFromDOM() {
	// Find the product form
	var productInfoWrapper = document.querySelector('.Product__InfoWrapper');
	if (!productInfoWrapper) {
		console.warn('Product form not found');
		return null;
	}

	// Find the product JSON data in the DOM
	var productJsonElement = productInfoWrapper.querySelector('[data-product-json]');
	if (!productJsonElement) {
		console.warn('Product JSON data not found in DOM');
		return null;
	}

	// Parse the product data from the JSON script tag
	try {
		var productData = JSON.parse(productJsonElement.innerHTML);
		var product = productData.product;
		
		if (!product || !product.variants || !Array.isArray(product.variants)) {
			console.warn('Invalid product data structure');
			return null;
		}
		
		return {
			product: product,
			selectedVariantId: productData.selected_variant_id,
			inventories: productData.inventories || {}
		};
	} catch (parseError) {
		console.error('Error parsing product JSON data:', parseError);
		return null;
	}
}

function checkSizeAvailabilityInProduct(product, size) {
	var isSizeAvailable = false;
	var isSizeInStock = false;

    
	
	// Check if the size exists and is available
	product.variants.forEach(function(variant) {
		if (variant.title.toLowerCase().includes(size.toLowerCase())) {
			isSizeAvailable = true;
			if (variant.available) {
				isSizeInStock = true;
			}
		}
	});
	
	return {
		isAvailable: isSizeAvailable,
		isInStock: isSizeInStock
	};
}

document.addEventListener('click', function (event) {
	if (!event.target.matches('.ColorSwatch')) return;
	
	// Original functionality for variant swatches
	var productSwatchImage = event.target.getAttribute('data-image-large');
	var productSwatchSelected = document.getElementsByClassName('ColorSwatchSelected')[0];

	if (productSwatchSelected) {
		productSwatchSelected.style.backgroundImage = 'url(' + productSwatchImage + ')';
	}
}, false);

// Add event listener for size changes
document.addEventListener('change', function(event) {
	if (event.target.classList.contains('SizeSwatch__Radio')) {
		// Update color swatch availability when size changes
		var swatchesComponent = document.querySelector('associated-collection-swatches');
		if (swatchesComponent && typeof swatchesComponent.boundUpdateColorSwatchAvailability === 'function') {
			swatchesComponent.boundUpdateColorSwatchAvailability();
		}
	}
}, false);

// Check color availability on page load
document.addEventListener('DOMContentLoaded', function() {
	// Wait a bit for the page to fully load, then check if web components are ready
	setTimeout(function() {
		// Check if web components are initialized
		var swatchesComponent = document.querySelector('associated-collection-swatches');
		if (swatchesComponent && typeof swatchesComponent.boundUpdateColorSwatchAvailability === 'function') {
			swatchesComponent.boundUpdateColorSwatchAvailability();
		}
	}, 500);
});

// Also check when the page is fully loaded (including images, etc.)
window.addEventListener('load', function() {
	// Check if web components are initialized
	var swatchesComponent = document.querySelector('associated-collection-swatches');
	if (swatchesComponent && typeof swatchesComponent.boundUpdateColorSwatchAvailability === 'function') {
		swatchesComponent.boundUpdateColorSwatchAvailability();
	}
});

// Function to reinitialize the product form
function reinitializeProductForm() {
	// Get product data from the DOM using utility function
	var productData = getProductDataFromDOM();
	if (!productData) {
		console.warn('Could not get product data from DOM');
		return;
	}

	var product = productData.product;
	
	// Find the currently selected size
	var selectedSize = null;
	var sizeRadios = document.querySelectorAll('.SizeSwatch__Radio:checked');
	if (sizeRadios.length > 0) {
		selectedSize = sizeRadios[0].value;
	}
	
	// Find the matching variant for the selected size
	var selectedVariant = null;
	if (selectedSize) {
		product.variants.forEach(function(variant) {
			if (variant.title.toLowerCase().includes(selectedSize.toLowerCase())) {
				selectedVariant = variant;
			}
		});
	}
	
	// If no variant found for selected size, use the first available variant
	if (!selectedVariant) {
		selectedVariant = product.variants[0];
	}
	
	// Find the product form
	var productForm = document.querySelector('.ProductForm');
	if (!productForm) return;
	
	// Update the variant select
	var variantSelect = productForm.querySelector('select[name="id"]');
	if (variantSelect && selectedVariant) {
		// Update the select value
		variantSelect.value = selectedVariant.id;
		
		// Update any hidden input fields
		var hiddenVariantInput = productForm.querySelector('input[name="id"]');
		if (hiddenVariantInput) {
			hiddenVariantInput.value = selectedVariant.id;
		}
		
		// Trigger change event on the select
		var changeEvent = new Event('change', { bubbles: true });
		variantSelect.dispatchEvent(changeEvent);
	}
	
	// Trigger the variant:changed event with the correct variant data
	var variantChangedEvent = new CustomEvent('variant:changed', {
		detail: {
			variant: selectedVariant
		}
	});
	document.dispatchEvent(variantChangedEvent);
	
	// Force a re-render of any price elements
	var priceElements = document.querySelectorAll('[data-money-convertible]');
	priceElements.forEach(function(element) {
		// Trigger a custom event to force price update
		var priceUpdateEvent = new CustomEvent('price:update', {
			detail: { variant: selectedVariant }
		});
		element.dispatchEvent(priceUpdateEvent);
	});
	
	// Update add to cart button state
	var addToCartButton = productForm.querySelector('button[type="submit"]');
	if (addToCartButton) {
		if (selectedVariant && selectedVariant.available) {
			addToCartButton.disabled = false;
			addToCartButton.textContent = addToCartButton.getAttribute('data-add-to-cart-text') || 'Add to cart';
		} else {
			addToCartButton.disabled = true;
			addToCartButton.textContent = 'Sold out';
		}
	}
}

/**
 * Associated Collection Swatches Web Component
 * Handles the main swatch functionality for associated collection products
 */
class AssociatedCollectionSwatches extends HTMLElement {
	constructor() {
		super();
		this.sectionId = this.getAttribute('data-section-id');
		this.currentSize = null;
		this.swatches = [];
		this.isUpdating = false;
		this.boundHandleSizeChange = this.handleSizeChange.bind(this);
		this.boundHandleSwatchChange = this.handleSwatchChange.bind(this);
		this.boundUpdateColorSwatchAvailability = this.updateColorSwatchAvailability.bind(this);
		this.boundEnableAllColorSwatches = this.enableAllColorSwatches.bind(this);
		this.utils = window.WebComponentUtils;
	}

	connectedCallback() {
		this.initialize();
	}

	disconnectedCallback() {
		this.cleanup();
	}

	initialize() {
		// Find all associated product swatches
		this.swatches = this.querySelectorAll('.ColorSwatch__Radio[name="associated-product"]');
		
		// Add event listeners
		this.addEventListeners();
		
		// Initial availability check
		// console.log('AssociatedCollectionSwatches: Calling updateColorSwatchAvailability');
		this.boundUpdateColorSwatchAvailability();
		
		// Set loading state attribute
		this.setAttribute('data-initialized', 'true');
	}

	addEventListeners() {
		// Listen for size changes from size swatch manager
        document.addEventListener('size:changed', this.boundHandleSizeChange);
		
		// Listen for general size changes
        document.addEventListener('change', this.boundHandleSizeChange);
		
		// Listen for swatch clicks
		this.swatches.forEach(swatch => {
            swatch.addEventListener('change', this.boundHandleSwatchChange);
		});
		
		// Listen for section updates
        // document.addEventListener('shopify:section:load', this.handleSectionLoad.bind(this));
	}

	cleanup() {
		// Remove event listeners
		document.removeEventListener('size:changed', this.boundHandleSizeChange);
		document.removeEventListener('change', this.boundHandleSizeChange);
		
		this.swatches.forEach(swatch => {
			swatch.removeEventListener('change', this.boundHandleSwatchChange);
		});
		
		this.isUpdating = false;
		this.removeAttribute('data-loading');
		this.removeAttribute('data-initialized');
	}

	handleSizeChange(event) {
		
		if (this.isUpdating) {
			// console.log('AssociatedCollectionSwatches: Skipping size change - updating in progress');
			return;
		}
		
		// Handle both size swatch manager events and direct size changes
		if (event.type === 'size:changed') {
			this.currentSize = event.detail.size;
			// console.log('AssociatedCollectionSwatches: Size changed via event to', this.currentSize);
		} else if (event.target.classList.contains('SizeSwatch__Radio')) {
			this.currentSize = event.target.value;
			// console.log('AssociatedCollectionSwatches: Size changed via radio to', this.currentSize);
		}
		
		if (this.currentSize) {
			// console.log('AssociatedCollectionSwatches: Calling updateColorSwatchAvailability from handleSizeChange');
			this.boundUpdateColorSwatchAvailability();
			
			// Also update the variant data when size changes
			setTimeout(() => {
				this.updateVariantForCurrentSize();
			}, 100);
		}
	}

	handleSwatchChange(event) {
		var swatchRadio = event.target;
		var productUrl = swatchRadio.getAttribute('data-product-url');
		
		if (!productUrl) return;
		
		// Prevent multiple simultaneous updates
		if (this.isUpdating) {
			event.preventDefault();
			return;
		}
		
		this.isUpdating = true;
		this.setAttribute('data-loading', 'true');
		
		// Store current size selection
		var currentSizeSelection = null;
		var sizeRadios = document.querySelectorAll('.SizeSwatch__Radio:checked');
		if (sizeRadios.length > 0) {
			currentSizeSelection = sizeRadios[0].value;
		}
		
		// Use Sections API to update the main product section
		var mainProductSection = null;
		if (this.utils && this.utils.safeQuerySelector) {
			mainProductSection = this.utils.safeQuerySelector(document, '.Product, [data-section-type="product"]');
		} else {
			mainProductSection = document.querySelector('.Product, [data-section-type="product"]');
		}
		
		if (mainProductSection) {
			this.updateProductSection(mainProductSection, productUrl, currentSizeSelection)
				.catch(error => {
					console.error('Error updating product section:', error);
					this.isUpdating = false;
					this.removeAttribute('data-loading');
					// Fallback to page navigation on error
					window.location.href = productUrl;
				});
		} else {
			// Fallback to page navigation
			this.isUpdating = false;
			this.removeAttribute('data-loading');
			window.location.href = productUrl;
		}
	}

	async updateProductSection(mainProductSection, productUrl, currentSizeSelection) {
		var sectionId = mainProductSection.getAttribute('data-section-id');
		
		// Show loading state
		if (this.utils && this.utils.triggerEvent) {
			this.utils.triggerEvent(document, 'theme:loading:start');
		} else {
			document.dispatchEvent(new CustomEvent('theme:loading:start'));
		}
		
		try {
			// Update URL without page reload first
			const newUrl = new URL(productUrl, window.location.origin);
			window.history.pushState({}, '', newUrl.pathname + newUrl.search);
			
			// Fetch the new product page content
			const response = await fetch(productUrl + '?section_id=' + sectionId, {
				credentials: 'same-origin',
				method: 'GET'
			});
			
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			
			const content = await response.text();
			
			// Create temporary element to parse the response
			var tempElement = document.createElement('div');
			tempElement.innerHTML = content;
			
			// Find the main product section in the response
			var newSectionContent = tempElement.querySelector('[data-section-id="' + sectionId + '"]');
			
			if (newSectionContent) {
				// Update the current section with new content
				mainProductSection.innerHTML = newSectionContent.innerHTML;
				
				// Trigger section reload events
				this.triggerSectionEvents(sectionId);
				
				// Reinitialize components after content update
				setTimeout(() => {
					this.handlePostUpdate(currentSizeSelection);
				}, 150);
				
				// End loading state
				if (this.utils && this.utils.triggerEvent) {
					this.utils.triggerEvent(document, 'theme:loading:end');
				} else {
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
				}
				
				// Update page title and meta tags if available
				if (typeof this.updatePageMetadata === 'function') {
					this.updatePageMetadata(tempElement);
				}
				
				// Trigger custom event for other components
				if (this.utils && this.utils.triggerEvent) {
					this.utils.triggerEvent(document, 'product:switched', {
						productUrl: productUrl,
						sizeSelection: currentSizeSelection,
						sectionId: sectionId
					});
				} else {
					document.dispatchEvent(new CustomEvent('product:switched', {
						detail: {
							productUrl: productUrl,
							sizeSelection: currentSizeSelection,
							sectionId: sectionId
						}
					}));
				}
				
			} else {
				throw new Error('Product section not found in fetched HTML');
			}
		} catch (error) {
			console.error('Error updating product section:', error);
			// Revert URL change on error
			window.history.back();
			throw error;
		} finally {
			this.isUpdating = false;
			this.removeAttribute('data-loading');
		}
	}

	updatePageMetadata(doc) {
		// Update page title
		const newTitle = doc.querySelector('title');
		if (newTitle) {
			document.title = newTitle.textContent;
		}
		
		// Update meta description
		const newMetaDesc = doc.querySelector('meta[name="description"]');
		if (newMetaDesc) {
			let existingMetaDesc = document.querySelector('meta[name="description"]');
			if (existingMetaDesc) {
				existingMetaDesc.setAttribute('content', newMetaDesc.getAttribute('content'));
			}
		}
		
		// Update Open Graph tags
		const ogTags = ['og:title', 'og:description', 'og:url', 'og:image'];
		ogTags.forEach(tag => {
			const newTag = doc.querySelector(`meta[property="${tag}"]`);
			if (newTag) {
				let existingTag = document.querySelector(`meta[property="${tag}"]`);
				if (existingTag) {
					existingTag.setAttribute('content', newTag.getAttribute('content'));
				}
			}
		});
	}

	triggerSectionEvents(sectionId) {
		// Trigger section reload event for any JavaScript components
		if (this.utils && this.utils.triggerEvent) {
			this.utils.triggerEvent(document, 'shopify:section:load', { sectionId: sectionId });
			this.utils.triggerEvent(document, 'shopify:section:reload', { sectionId: sectionId });
			this.utils.triggerEvent(document, 'section:updated', { sectionId: sectionId });
		} else {
			// Fallback to direct event dispatching
			document.dispatchEvent(new CustomEvent('shopify:section:load', {
				detail: { sectionId: sectionId }
			}));
			document.dispatchEvent(new CustomEvent('shopify:section:reload', {
				detail: { sectionId: sectionId }
			}));
			document.dispatchEvent(new CustomEvent('section:updated', {
				detail: { sectionId: sectionId }
			}));
		}
	}

	handlePostUpdate(currentSizeSelection) {
		// Reinitialize the product form with proper variant data
		this.reinitializeProductForm();
		
		// Handle size availability after content update
		if (currentSizeSelection) {
			setTimeout(() => {
				this.handleSizeAvailability(currentSizeSelection);
			}, 200);
		}
		
		// Trigger gallery reinitialization through the web component system
		var galleryComponent = document.querySelector('product-gallery');
		if (galleryComponent && typeof galleryComponent.reinitializeGallery === 'function') {
			galleryComponent.reinitializeGallery();
		} else {
			// Fallback: trigger a swatch changed event for the gallery component to listen to
			var swatchChangedEvent = new CustomEvent('swatch:changed', {
				detail: { 
					sizeSelection: currentSizeSelection,
					swatchesComponent: this 
				}
			});
			document.dispatchEvent(swatchChangedEvent);
		}
		
		// Update variant data for the current size
		if (currentSizeSelection) {
			this.currentSize = currentSizeSelection;
			setTimeout(() => {
				this.updateVariantForCurrentSize();
			}, 300);
		}
	}

	updateColorSwatchAvailability() {
		// Get current selected size
		var sizeRadios = document.querySelectorAll('.SizeSwatch__Radio:checked');
		if (sizeRadios.length > 0) {
			this.currentSize = sizeRadios[0].value;
		}
		
		if (!this.currentSize) {
			// No size selected, enable all color swatches
			this.boundEnableAllColorSwatches();
			return;
		}
        
		// Check availability for each associated product
		this.swatches.forEach(swatchRadio => {
			var productUrl = swatchRadio.getAttribute('data-product-url');
			var swatchLabel = document.querySelector('label[for="' + swatchRadio.id + '"]');
			
			if (productUrl && swatchLabel) {
				this.checkProductAvailability(productUrl, swatchRadio, swatchLabel);
			}
		});
	}

	async checkProductAvailability(productUrl, swatchRadio, swatchLabel) {
		await this.fetchAndCheckAvailability(productUrl, swatchRadio, swatchLabel);
	}

	async fetchAndCheckAvailability(productUrl, swatchRadio, swatchLabel) {
		try {
			// Extract product handle from URL
			var productHandle = getProductHandleFromUrl(productUrl);
			if (!productHandle) {
				this.updateSwatchAvailability(swatchRadio, swatchLabel, true, true);
				return;
			}
			
			// Fetch product data
			const response = await fetch(productUrl + '.js');
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			
			const productData = await response.json();
			
			// Validate product data
			if (!isValidProductData(productData)) {
				this.updateSwatchAvailability(swatchRadio, swatchLabel, true, true);
				return;
			}
			
			// Check size availability
			var availability = checkSizeAvailabilityInProduct(productData, this.currentSize);
			
			this.updateSwatchAvailability(swatchRadio, swatchLabel, availability.isAvailable, availability.isInStock);
			
		} catch (error) {
			console.error('Error fetching product availability:', error);
			// Default to available on error
			this.updateSwatchAvailability(swatchRadio, swatchLabel, true, true);
		}
	}

	updateSwatchAvailability(swatchRadio, swatchLabel, isSizeAvailable, isSizeInStock) {
		if (isSizeAvailable && isSizeInStock) {
			// Size is available and in stock - enable swatch
			swatchLabel.classList.remove('ColorSwatch--disabled', 'ColorSwatch--out-of-stock');
			swatchLabel.style.opacity = '1';
			swatchLabel.style.cursor = 'pointer';
			swatchLabel.removeAttribute('title');
		} else if (isSizeAvailable && !isSizeInStock) {
			// Size exists but is out of stock - show out of stock state
			swatchLabel.classList.add('ColorSwatch--out-of-stock');
			swatchLabel.classList.remove('ColorSwatch--disabled');
			swatchLabel.style.opacity = '1';
			swatchLabel.style.cursor = 'not-allowed';
			swatchLabel.setAttribute('title', 'This color is out of stock in the selected size');
		} else {
			// Size doesn't exist - disable swatch
			swatchLabel.classList.add('ColorSwatch--disabled');
			swatchLabel.classList.remove('ColorSwatch--out-of-stock');
			swatchLabel.style.opacity = '1';
			swatchLabel.style.cursor = 'not-allowed';
			swatchLabel.setAttribute('title', 'This color is not available in the selected size');
		}
	}

	enableAllColorSwatches() {
		this.swatches.forEach(swatchRadio => {
			var swatchLabel = document.querySelector('label[for="' + swatchRadio.id + '"]');
			if (swatchLabel) {
				swatchLabel.classList.remove('ColorSwatch--disabled', 'ColorSwatch--out-of-stock');
				swatchLabel.style.opacity = '1';
				swatchLabel.style.cursor = 'pointer';
				swatchLabel.removeAttribute('title');
			}
		});
	}

	handleSizeAvailability(previousSize) {
		// Find all size radio buttons in the new product
		var sizeRadios = document.querySelectorAll('.SizeSwatch__Radio');
		var availableSizes = [];
		var previousSizeAvailable = false;
		var firstAvailableSize = null;
		
		// Check which sizes are available
		sizeRadios.forEach(radio => {
			var sizeValue = radio.value;
			var isAvailable = !radio.disabled;
			
			if (isAvailable) {
				availableSizes.push(sizeValue);
				if (!firstAvailableSize) {
					firstAvailableSize = sizeValue;
				}
				if (sizeValue === previousSize) {
					previousSizeAvailable = true;
				}
			}
		});
		
		// Handle size selection logic
		if (previousSizeAvailable) {
			// Previous size is available, keep it selected
			var previousSizeRadio = document.querySelector('.SizeSwatch__Radio[value="' + previousSize + '"]');
			if (previousSizeRadio) {
				previousSizeRadio.checked = true;
				previousSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
			}
		} else if (firstAvailableSize) {
			// Previous size not available, select first available size
			var firstAvailableRadio = document.querySelector('.SizeSwatch__Radio[value="' + firstAvailableSize + '"]');
			if (firstAvailableRadio) {
				firstAvailableRadio.checked = true;
				firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}
	}

	reinitializeProductComponents() {
		// Reinitialize the product form
		this.reinitializeProductForm();
	}

	async reinitializeProductForm() {
		// Find the product form
		var productForm = this.querySelector('.ProductForm');
		if (!productForm) {
			console.warn('Product form not found for reinitialization');
			return;
		}

		try {
			// Get product data from the DOM using utility function
			var productData = getProductDataFromDOM();
			if (!productData) {
				console.warn('Could not get product data from DOM');
				return;
			}

			var product = productData.product;
			
			// Find the currently selected size
			var selectedSize = null;
			var sizeRadios = document.querySelectorAll('.SizeSwatch__Radio:checked');
			if (sizeRadios.length > 0) {
				selectedSize = sizeRadios[0].value;
			}
			
			// Find the matching variant for the selected size
			var selectedVariant = null;
			if (selectedSize) {
				product.variants.forEach(function(variant) {
					if (variant.title.toLowerCase().includes(selectedSize.toLowerCase())) {
						selectedVariant = variant;
					}
				});
			}
			
			// If no variant found for selected size, use the first available variant
			if (!selectedVariant) {
				selectedVariant = product.variants[0];
			}
			
			// Update the variant select
			var variantSelect = productForm.querySelector('select[name="id"]');
			if (variantSelect && selectedVariant) {
				// Update the select value
				variantSelect.value = selectedVariant.id;
				
				// Update any hidden input fields
				var hiddenVariantInput = productForm.querySelector('input[name="id"]');
				if (hiddenVariantInput) {
					hiddenVariantInput.value = selectedVariant.id;
				}
				
				// Trigger change event on the select
				var changeEvent = new Event('change', { bubbles: true });
				variantSelect.dispatchEvent(changeEvent);
			}
			
			// Trigger the variant:changed event with the correct variant data
			var variantChangedEvent = new CustomEvent('variant:changed', {
				detail: {
					variant: selectedVariant,
					product: product
				}
			});
			document.dispatchEvent(variantChangedEvent);
			
			// Force a re-render of any price elements
			var priceElements = document.querySelectorAll('[data-money-convertible]');
			priceElements.forEach(function(element) {
				// Trigger a custom event to force price update
				var priceUpdateEvent = new CustomEvent('price:update', {
					detail: { variant: selectedVariant }
				});
				element.dispatchEvent(priceUpdateEvent);
			});
			
			// Update add to cart button state
			var addToCartButton = productForm.querySelector('button[type="submit"]');
			if (addToCartButton) {
				if (selectedVariant && selectedVariant.available) {
					addToCartButton.disabled = false;
					addToCartButton.textContent = addToCartButton.getAttribute('data-add-to-cart-text') || 'Add to cart';
				} else {
					addToCartButton.disabled = true;
					addToCartButton.textContent = 'Sold out';
				}
			}
			
			console.log('Product form reinitialized successfully with variant:', selectedVariant);
			
		} catch (error) {
			console.error('Error reinitializing product form:', error);
			
			// Fallback: try to use the global reinitializeProductForm function
			if (typeof reinitializeProductForm === 'function') {
				reinitializeProductForm();
			}
		}

		// Trigger form-specific events
		var formLoadEvent = new CustomEvent('form:reload', {
			detail: { form: productForm }
		});
		document.dispatchEvent(formLoadEvent);
	}

	async updateVariantForCurrentSize() {
		if (!this.currentSize) {
			console.log('AssociatedCollectionSwatches: No current size selected for variant update');
			return;
		}

		try {
			// Get product data from the DOM using utility function
			var productData = getProductDataFromDOM();
			if (!productData) {
				console.warn('Could not get product data from DOM');
				return;
			}

			var product = productData.product;
			
			// Find the matching variant for the current size
			var selectedVariant = null;
			console.log(product.variants, this.currentSize)
			product.variants.forEach(function(variant) {
				console.log(variant.title.toLowerCase(), this.currentSize.toLowerCase())
				if (!selectedVariant && variant.title.toLowerCase().includes(this.currentSize.toLowerCase())) {
					selectedVariant = variant;
				}
			}.bind(this));
			
			// If no variant found for current size, use the first available variant
			if (!selectedVariant) {
				selectedVariant = product.variants[0];
			}
			
			// Update the variant select
			var productForm = this.querySelector('.ProductForm');
			if (productForm) {
				var variantSelect = productForm.querySelector('select[name="id"]');
				if (variantSelect && selectedVariant) {
					// Update the select value
					variantSelect.value = selectedVariant.id;
					
					// Update any hidden input fields
					var hiddenVariantInput = productForm.querySelector('input[name="id"]');
					if (hiddenVariantInput) {
						hiddenVariantInput.value = selectedVariant.id;
					}
					
					// Trigger change event on the select
					var changeEvent = new Event('change', { bubbles: true });
					variantSelect.dispatchEvent(changeEvent);
				}
			}
			
			// Trigger the variant:changed event with the correct variant data
			var variantChangedEvent = new CustomEvent('variant:changed', {
				detail: {
					variant: selectedVariant,
					product: product,
					updateAddToCartButton: true
				}
			});
			document.dispatchEvent(variantChangedEvent);
			
		} catch (error) {
			console.error('Error updating variant for current size:', error);
		}
	}
}

/**
 * Product Gallery Web Component
 * Handles gallery reinitialization and management
 */
class ProductGallery extends HTMLElement {
	constructor() {
		super();
		this.gallery = null;
		this.slideshow = null;
		this.boundHandleSectionLoad = this.handleSectionLoad.bind(this);
		this.boundHandleImageChanged = this.handleImageChanged.bind(this);
		this.boundHandleThumbnailClick = this.handleThumbnailClick?.bind(this) || null;
		this.thumbnailsNav = null;
	}

	connectedCallback() {
		this.initialize();
	}

	disconnectedCallback() {
		this.cleanup();
	}

	initialize() {
		// Find the gallery element
		this.gallery = this.querySelector('.Product__Gallery') || 
					   this.querySelector('.ProductGallery') ||
					   this.querySelector('[data-product-gallery]');
		
		// Initialize the slideshow if it exists
		this.initializeSlideshow();
		
		// Add event listeners
		this.addEventListeners();
	}

	initializeSlideshow() {
		var slideshowElement = this.querySelector('.Product__Slideshow');
		
		if (!slideshowElement) {
			// console.log('No slideshow element found in product gallery');
			return;
		}

		// Get Flickity configuration from data attribute
		var flickityConfig = slideshowElement.getAttribute('data-flickity-config');
		
		if (!flickityConfig) {
			console.warn('No Flickity configuration found for slideshow');
			return;
		}

		try {
			var config = JSON.parse(flickityConfig);
			
			// Add onSelect callback for image changes
			config.onSelect = this.boundHandleImageChanged;
			
			// Initialize Flickity if available
			if (typeof Flickity !== 'undefined') {
				// Destroy existing instance if it exists
				if (slideshowElement.flickity) {
					slideshowElement.flickity.destroy();
				}
				
				this.slideshow = new Flickity(slideshowElement, config);
				// console.log('Product gallery slideshow initialized with Flickity');
				
				// Trigger theme events for compatibility
				setTimeout(() => {
					this.triggerThemeEvents();
				}, 100);

				// Ensure thumbnail navigation is wired
				this.bindThumbnailNavigation();
			} else {
				console.warn('Flickity library not available');
			}
		} catch (e) {
			console.error('Error parsing Flickity configuration:', e);
		}
	}

	bindThumbnailNavigation() {
		// Clean up any previous binding
		if (this.thumbnailsNav && this.boundHandleThumbnailClick) {
			this.thumbnailsNav.removeEventListener('click', this.boundHandleThumbnailClick);
		}

		// Locate the thumbnails nav (if present)
		this.thumbnailsNav = this.querySelector('.Product__SlideshowNav--thumbnails');
		if (!this.thumbnailsNav) return;

		// Lazily create the bound handler if not created in constructor (older browsers)
		if (!this.boundHandleThumbnailClick) {
			this.boundHandleThumbnailClick = this.handleThumbnailClick.bind(this);
		}

		this.thumbnailsNav.addEventListener('click', this.boundHandleThumbnailClick);
	}

	handleThumbnailClick(event) {
		const clickedThumb = event.target.closest('.Product__SlideshowNavImage');
		if (!clickedThumb) return;

		const imageId = clickedThumb.getAttribute('data-image-id');
		if (!imageId) return;

		// If we have a Flickity slideshow, switch to the matching slide
		if (this.slideshow) {
			event.preventDefault();
			const cells = this.querySelectorAll('.Carousel__Cell');
			let targetIndex = -1;
			for (let i = 0; i < cells.length; i++) {
				const cellImageId = cells[i].getAttribute('data-image-id');
				if (cellImageId && cellImageId.toString() === imageId.toString()) {
					targetIndex = i;
					break;
				}
			}
			if (targetIndex >= 0) {
				this.slideshow.selectCell(targetIndex);
			}
			return;
		}

		// Stack images fallback: if no slideshow, scroll to image when thumb is a span (no href)
		const href = clickedThumb.getAttribute('href');
		if (!href) {
			event.preventDefault();
			const target = this.querySelector('#Image' + imageId);
			if (target && target.scrollIntoView) {
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		}
	}

	addEventListeners() {
		// Listen for section load events
		document.addEventListener('shopify:section:load', this.boundHandleSectionLoad);
		document.addEventListener('gallery:init', this.boundHandleSectionLoad);
		
		// Listen for swatch changes to reinitialize gallery
		document.addEventListener('swatch:changed', this.reinitializeGallery.bind(this));
	}

	cleanup() {
		// Remove event listeners
		document.removeEventListener('shopify:section:load', this.boundHandleSectionLoad);
		document.removeEventListener('gallery:init', this.boundHandleSectionLoad);
		document.removeEventListener('swatch:changed', this.reinitializeGallery.bind(this));

		// Remove thumbnail click handler
		if (this.thumbnailsNav && this.boundHandleThumbnailClick) {
			this.thumbnailsNav.removeEventListener('click', this.boundHandleThumbnailClick);
			this.thumbnailsNav = null;
		}
		
		// Destroy Flickity instance
		if (this.slideshow) {
			this.slideshow.destroy();
			this.slideshow = null;
		}
	}

	handleSectionLoad(event) {
		// Check if this is a product section
		if (event.detail && event.detail.sectionId) {
			var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
			if (section && section.querySelector('.Product__Gallery')) {
				// This is a product section, ensure gallery is properly initialized
				setTimeout(() => {
					this.reinitializeGallery();
				}, 100);
			}
		}
	}

	handleImageChanged(index, element) {
		// Handle image change events from Flickity
		// console.log('Product gallery image changed to index:', index);
		
		// Trigger custom event for other components to listen to
		var imageChangeEvent = new CustomEvent('gallery:image:changed', {
			detail: { 
				index: index, 
				element: element,
				gallery: this.gallery 
			}
		});
		document.dispatchEvent(imageChangeEvent);
	}

	reinitializeGallery() {
		// console.log('Reinitializing product gallery...');
		
		// Wait a bit for the DOM to be fully updated
		setTimeout(() => {
			// First, ensure all images are properly loaded and sized
			var images = this.querySelectorAll('img');
			var imageLoadPromises = [];
			
			images.forEach(img => {
				// If image is already loaded, ensure it has proper dimensions
				if (img.complete) {
					// Force image to recalculate dimensions
					img.style.height = '';
					img.style.width = '';
					img.style.maxHeight = '';
					img.style.maxWidth = '';
					
					// Trigger a reflow to ensure proper sizing
					img.offsetHeight;
					
					// If image has no height, try to set a minimum height
					if (img.offsetHeight === 0) {
						img.style.minHeight = '200px';
						img.style.objectFit = 'contain';
					}
				} else {
					// Create a promise for image loading
					var loadPromise = new Promise((resolve) => {
						img.onload = () => {
							// Ensure proper sizing after load
							img.style.height = '';
							img.style.width = '';
							img.style.maxHeight = '';
							img.style.maxWidth = '';
							img.offsetHeight; // Force reflow
							resolve();
						};
						img.onerror = () => {
							console.warn('Failed to load image:', img.src);
							resolve();
						};
					});
					imageLoadPromises.push(loadPromise);
				}
			});
			
			// Wait for all images to load, then reinitialize gallery components
			Promise.all(imageLoadPromises).then(() => {
				// Fix AspectRatio containers that might have lost their height
				var aspectRatioContainers = this.querySelectorAll('.AspectRatio');
				aspectRatioContainers.forEach(container => {
					// Force recalculation of aspect ratio
					var aspectRatio = container.style.getPropertyValue('--aspect-ratio') || '1';
					container.style.setProperty('--aspect-ratio', aspectRatio);
					
					// Force a reflow to ensure proper sizing
					container.offsetHeight;
					
					// Ensure the container has proper dimensions
					if (container.offsetHeight === 0) {
						container.style.minHeight = '300px';
						container.style.height = 'auto';
					}
					
				});
				
				// Reinitialize the slideshow
				this.initializeSlideshow();
				// Ensure thumbnail navigation is bound after reinit
				this.bindThumbnailNavigation();
				
				// Trigger gallery-specific events
				var galleryLoadEvent = new CustomEvent('gallery:load', {
					detail: { gallery: this.gallery }
				});
				document.dispatchEvent(galleryLoadEvent);
				
				// Reinitialize image lazy loading
				var lazyImages = this.querySelectorAll('img[data-src], img[data-lazy]');
				lazyImages.forEach(img => {
					// Trigger lazy loading
					if (typeof lazySizes !== 'undefined') {
						lazySizes.loader.unveil(img);
					}
				});
				
				// Reinitialize any zoom functionality
				var zoomImages = this.querySelectorAll('[data-zoom], .zoom-enabled');
				zoomImages.forEach(img => {
					// Trigger zoom reinitialization if zoom library is available
					if (typeof window.Zoom !== 'undefined') {
						new window.Zoom(img);
					}
				});
				
				// Trigger any theme-specific gallery events
				var themeGalleryEvent = new CustomEvent('theme:gallery:reload', {
					detail: { gallery: this.gallery }
				});
				document.dispatchEvent(themeGalleryEvent);
				
				// Trigger Shopify-specific gallery events
				var shopifyGalleryEvent = new CustomEvent('shopify:gallery:reload', {
					detail: { gallery: this.gallery }
				});
				document.dispatchEvent(shopifyGalleryEvent);
				
				// Force a layout recalculation
				if (typeof window.requestAnimationFrame !== 'undefined') {
					window.requestAnimationFrame(() => {
						// Ensure gallery container has proper dimensions
						if (this.gallery && this.gallery.offsetHeight === 0) {
							this.gallery.style.minHeight = '300px';
						}
						
						if (this.gallery) {
							this.gallery.style.display = 'none';
							this.gallery.offsetHeight; // Force reflow
							this.gallery.style.display = '';
						}
						
						// Trigger a final resize event to ensure proper layout
						window.dispatchEvent(new Event('resize'));
						
						// Additional check for image heights after reflow
						setTimeout(() => {
							images.forEach(img => {
								if (img.offsetHeight === 0) {
									console.warn('Image still has 0 height after reflow:', img.src);
									img.style.minHeight = '200px';
									img.style.objectFit = 'contain';
								}
							});
						}, 100);
					});
				}
				
				// console.log('Product gallery reinitialized successfully');
			});
			
		}, 200); // Increased delay to ensure DOM is ready
	}

	// Public method to select a specific slide
	selectSlide(index) {
		if (this.slideshow) {
			this.slideshow.select(index);
		}
	}

	// Public method to get current slide index
	getCurrentSlideIndex() {
		if (this.slideshow) {
			return this.slideshow.selectedIndex;
		}
		return 0;
	}

	// Public method to resize the gallery
	resize() {
		if (this.slideshow) {
			this.slideshow.resize();
		}
	}

	// Public method to select slide by image ID (for old theme compatibility)
	selectSlideByImageId(imageId) {
		if (!this.slideshow) return;
		
		var cells = this.slideshow.cells;
		for (var i = 0; i < cells.length; i++) {
			var cell = cells[i].element;
			var cellImageId = cell.getAttribute('data-image-id');
			if (cellImageId && parseInt(cellImageId) === parseInt(imageId)) {
				this.slideshow.select(i);
				break;
			}
		}
	}

	// Public method to get slideshow instance (for old theme compatibility)
	getSlideshowInstance() {
		return this.slideshow;
	}

	// Public method to handle variant changes (for old theme compatibility)
	handleVariantChange(variant) {
		if (!variant || !variant.featured_image) return;
		
		// Select the slide with the variant's featured image
		this.selectSlideByImageId(variant.featured_image.id);
	}

	// Public method to trigger theme events (for old theme compatibility)
	triggerThemeEvents() {
		// Trigger events that the old theme expects
		var themeEvent = new CustomEvent('theme:gallery:ready', {
			detail: { gallery: this.gallery, slideshow: this.slideshow }
		});
		document.dispatchEvent(themeEvent);
	}
}

/**
 * Size Swatch Manager Web Component
 * Handles size swatch functionality and availability
 */
class SizeSwatchManager extends HTMLElement {
	constructor() {
		super();
		this.sizeRadios = [];
		this.boundHandleSizeChange = this.handleSizeChange.bind(this);
	}

	connectedCallback() {
		this.initialize();
	}

	disconnectedCallback() {
		this.cleanup();
	}

	initialize() {
		// Find all size radio buttons
		this.sizeRadios = this.querySelectorAll('.SizeSwatch__Radio');
		
		// Add event listeners
		this.addEventListeners();
	}

	addEventListeners() {
		// Listen for size changes
		this.sizeRadios.forEach(radio => {
			radio.addEventListener('change', this.boundHandleSizeChange);
		});
	}

	cleanup() {
		// Remove event listeners
		this.sizeRadios.forEach(radio => {
			radio.removeEventListener('change', this.boundHandleSizeChange);
		});
	}

	handleSizeChange(event) {
		// Trigger color swatch availability update
		var swatchesComponent = document.querySelector('associated-collection-swatches');
		if (swatchesComponent && typeof swatchesComponent.boundUpdateColorSwatchAvailability === 'function') {
			swatchesComponent.boundUpdateColorSwatchAvailability();
		}
	}
}

// Register the web components
customElements.define('associated-collection-swatches', AssociatedCollectionSwatches);
customElements.define('product-gallery', ProductGallery);
customElements.define('size-swatch-manager', SizeSwatchManager);

// Auto-initialize web components when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
	
	// Prevent old theme system from initializing gallery when web component is present
	var galleryComponent = document.querySelector('product-gallery');
	if (galleryComponent) {
		// console.log('ProductGallery web component detected, preventing old theme initialization');
		
		// Override the old theme's Carousel initialization for product galleries
		var originalCarousel = window.Carousel;
		if (originalCarousel) {
			window.Carousel = function(element, options) {
				// Check if this is a product gallery carousel
				var isProductGallery = element.closest('product-gallery') || 
									  element.closest('.Product__Gallery') ||
									  element.classList.contains('Product__Slideshow');
				
				if (isProductGallery) {
					// console.log('Preventing old theme Carousel initialization for product gallery');
					// Return a dummy object to prevent errors
					return {
						destroy: function() {},
						select: function() {},
						resize: function() {},
						on: function() {},
						off: function() {}
					};
				}
				
				// For non-product galleries, use the original Carousel
				return new originalCarousel(element, options);
			};
			
			// Copy static methods from original Carousel
			Object.setPrototypeOf(window.Carousel, originalCarousel);
			Object.setPrototypeOf(window.Carousel.prototype, originalCarousel.prototype);
		}
	}
});

// Global utility functions for web components
window.WebComponentUtils = {
	// Debounce function for performance
	debounce: function(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	},
	
	// Throttle function for performance
	throttle: function(func, limit) {
		let inThrottle;
		return function() {
			const args = arguments;
			const context = this;
			if (!inThrottle) {
				func.apply(context, args);
				inThrottle = true;
				setTimeout(() => inThrottle = false, limit);
			}
		};
	},
	
	// Safe query selector with error handling
	safeQuerySelector: function(element, selector) {
		try {
			return element.querySelector(selector);
		} catch (error) {
			console.warn('Query selector error:', error);
			return null;
		}
	},
	
	// Check if element is in viewport
	isInViewport: function(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},
	
	// Trigger custom events safely
	triggerEvent: function(element, eventName, detail = {}) {
		try {
			const event = new CustomEvent(eventName, {
				detail: detail,
				bubbles: true,
				cancelable: true
			});
			element.dispatchEvent(event);
		} catch (error) {
			console.warn('Event trigger error:', error);
		}
	}
};